import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=6ae69c74&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=6ae69c74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae69c74",
  null
  
)

export default component.exports